import classNames from "classnames";
import * as React from "react";

interface Props {
  heading?: string;
  title: string;
  category: string;
  chipColor?: string;
  chipText?: string;
  isDance?: boolean;
}

const TitleSectionFormRegistration: React.FC<Props> = ({
  title,
  category = "SMA",
  heading = "Pendaftaran Piala by.U",
  chipColor = "#00BCF1",
  chipText = "",
  isDance = false,
}) => {
  return (
    <div className="py-[16px] px-[24px]">
      <div className="flex items-center gap-x-[8px]">
        <p className="leading-none text-[12px] text-[#1F2D3D]">{heading}</p>

        {isDance ? (
          <div
            style={{ backgroundColor: chipColor }}
            className={`px-[4px] py-[2px] rounded-[4px]`}
          >
            <p className="leading-none text-white font-semibold text-[11px]">
              {chipText}
            </p>
          </div>
        ) : (
          <div
            className={classNames("px-[4px] py-[2px] rounded-[4px]", {
              "bg-[#00BCF1]": category?.includes("SMA"),
              "bg-[#77B341]": category?.includes("SMP"),
            })}
          >
            <p className="leading-none text-white font-semibold text-[11px]">
              {category}
            </p>
          </div>
        )}
      </div>
      <h1 className="leading-none text-[#1F2D3D] text-[18px] font-semibold pt-[8px]">
        {title}
      </h1>
    </div>
  );
};

export default TitleSectionFormRegistration;
